// extracted by mini-css-extract-plugin
export default {"noMark":"styles_noMark__EOsW6"};